const tr_TR = {
  "首页": "Ana Sayfa",
  '收藏': 'Favoriler',
  home: {
    "GLOBAL INDUSTRIAL INTELLIGENCE TRADING PLATFORM": "Küresel Endüstriyel Zekâ Ticaret Platformu",
    "设备分类": "Ekipman Kategorileri",
    "请输入内容": "Lütfen içerik girin",
    "请输入关键词": "Lütfen anahtar kelime girin",
    "搜索": "Ara",
    "供应大厅": "Tedarik Merkezi",
    "查看更多": "Daha Fazla Görüntüle", 
    "采购大厅": "Satınalma Merkezi",
    "截止日期": "Son Teslim Tarihi",
    "交货期限": "Teslim Süresi",
    "数量": "Miktar",
    "去询价": "Fiyat Sor",
    "平台介绍": "Platform Tanıtımı",
    "新闻动态": "Haberler",
    "产品名称": "Ürün Adı",
    "产品描述": "Ürün Açıklaması",
    "供应商": "Tedarikçi",
    "月供应量": "Aylık Tedarik Kapasitesi",
    "物流方式": "Lojistik Yöntemi",
    "询价": "Fiyat Teklifi İste",
    "平台介绍详情": "\"Bir standart, iki ekosistem, üç varlık\" ilkesiyle havacılık endüstri ürünleri ithalat/ihracatına odaklanan Zhuhai Airshow kaynaklarını kullanarak sergi ticaretini normalleştiriyor, dijitalleştiriyor ve uluslararasılaştırıyoruz. Hedefimiz dünya standartlarında kapsamlı bir havacılık endüstri ticaret platformu olmaktır.",
    "琴航航空工业品平台": "Qinhang Havacılık Endüstri Ürünleri Platformu",
    "推荐品牌": "Önerilen Markalar",
	"推荐":'Önerilen',
    "全球工业化智能解决方案": "Küresel Endüstriyel Akıllı Çözümler",
    "二手飞机推荐": "İkinci El Uçak Önerileri",
    "供求大厅": "Arz-Talep Merkezi",
    "更多供求": "Daha Fazla Arz-Talep",
    "全面定制化供应链服务": "Tam Özelleştirilmiş Tedarik Zinciri Hizmeti",
    "立即体验AI助手": "AI Asistanı Hemen Deneyin",
    "AI助手": "AI Asistan"
  },
  aiObject: {
    "title": "AI Akıllı Asistan",
    "connected": "Bağlandı",
    "placeholder": "Lütfen sorunuzu girin",
    "send": "Gönder",
    "stop": "Üretimi Durdur",
    "clear": "Kayıtları Temizle",
    "welcome": "Merhaba! Ben AI akıllı asistanım. Size nasıl yardımcı olabilirim?",
    "thinking": "Düşünüyorum...",
    "error": "Üzgünüm, şu anda sorunuzu yanıtlayamıyorum. Lütfen daha sonra tekrar deneyin.",
    "networkError": "Üzgünüm, ağ bağlantısında bir sorun oluştu. Lütfen daha sonra tekrar deneyin.",
    "stopped": "Üretim durduruldu",
    "confirmClose": "AI asistanı içerik üretiyor. Kapatmak istediğinizden emin misiniz?",
    "notice": "Uyarı",
    "confirm": "Onayla",
    "cancel": "İptal"
  },
  PageHeader: {
    "首页": "Ana Sayfa",
    "供应大厅": "Tedarik Merkezi",
    "采购大厅": "Satınalma Merkezi",
    "二手飞机库": "ikinci el uçağ",
    "备件商城": "Yedek Parça Mağazası",
    "招采平台": "İhale Platformu",
    "解决方案": "Çözümler",
    "新闻中心": "Haberler",
    "关于我们": "Hakkımızda",
    "简体中文": "Basitleştirilmiş Çince",
    "登录/注册": "Giriş/Kayıt",
    "欢迎您走进琴航科技": "Qinhang Teknoloji'ye Hoş Geldiniz",
    "已退出登录": "Çıkış Yapıldı"
},
  reservation: {
    "预约": "Rezervasyon",
    
    // 头部横幅文本
    "title1": "IDEF'te Connect Tech ile Tanışın",
    "title2": "2025",
    "title3": "Savunma Endüstrisinin Tüm Aktörleri Tek Çatı Altında",
    "title4": "22-27 Temmuz 2025 - Stand 8-C14A",
    
    // 内容描述段落
    "desc1": "IDEF 2025 17. Uluslararası Savunma Sanayi Fuarı, Türkiye Cumhuriyeti Milli Savunma Bakanlığı ev sahipliğinde, Türkiye Cumhuriyeti Cumhurbaşkanlığı Savunma Sanayii Başkanlığı desteğiyle, Türk Silahlı Kuvvetlerini Güçlendirme Vakfı yönetim ve sorumluluğunda, KFA Fuar Organizasyon A.Ş. tarafından 22-27 Temmuz 2025 tarihleri arasında İstanbul Fuar Merkezi'nde düzenlenecektir.",
    "desc2": "Connect Tech ve ortağı",
    "desc2_link": "Bernier",
    "desc2_cont": "Stand 8-C14A'da katılın. NVIDIA Elite Partner olarak Connect Tech ürünleri, insanlı ve insansız uygulamalar için küçük, düşük güçlü, sağlamlaştırılmış çözümler içerir. Bu kompakt ve güçlü kenar cihazları, taktik kenarda gerçek zamanlı karar verme sağlayan çeşitli araçlara kolayca taşınabilir veya yerleştirilebilir.",
    "desc3": "Uygulamanızı ayrıntılı olarak tartışmak ve özel tasarım gereksinimleriniz için potansiyel çözümler hakkında bilgi edinmek için şimdi bir toplantı ayırtın.",
    "desc4": "Toplantınızı planlamak için lütfen formu doldurun.",
    "required_note": "zorunlu alanlar",
    
    // 表单标签
    "label_salutation": "Hitap:",
    "label_first_name": "Adı:",
    "label_last_name": "Soyadı:",
    "label_email": "E-posta:",
    "label_job_title": "Meslek:",
    "label_company": "Şirket:",
    "label_phone": "Telefon:",
    "label_country": "Ülke:",
    "label_message": "Mesaj:",
    
    // 占位符文本
    "ph_choose": "—Lütfen bir seçenek seçin—",
    "ph_first_name": "Lütfen adınızı girin",
    "ph_last_name": "Lütfen soyadınızı girin",
    "ph_email": "Lütfen e-postanızı girin",
    "ph_job_title": "Lütfen mesleğinizi girin",
    "ph_company": "Lütfen şirketinizi girin",
    "ph_phone": "Lütfen telefon numaranızı girin",
    "ph_country": "Lütfen ülkenizi girin",
    "ph_message": "Lütfen mesajınızı veya özel gereksinimlerinizi girin",
    
    // 按钮和状态文本
    "btn_submit": "Gönder",
    "btn_submitting": "Gönderiliyor...",
    "msg_success": "Rezervasyon başarıyla gönderildi! Yakında sizinle iletişime geçeceğiz.",
    "msg_validation": "Lütfen tüm zorunlu alanları doğru şekilde doldurun",
    "msg_error": "Rezervasyon gönderilemedi. Lütfen tekrar deneyin."
  },
  CommonFooter: {
    "琴航（广东横琴）科技有限公司": "Qinhang (Guangdong Hengqin) Teknoloji Ltd. Şti.",
    "400-000-0000": "400-000-0000",
    "地址：珠海市香洲区厚朴道398号横琴国际科技创新中心 7栋708-2": "Adres: Bina 7, Oda 708-2, Hengqin Uluslararası Bilim ve Teknoloji İnovasyon Merkezi, Houpu Yolu No:398, Xiangzhou Bölgesi, Zhuhai",
    "contactEmail": "E-posta：Kinghang@e99.cn",
    
    // 底部导航
    "关于我们": "Hakkımızda",
    "供应大厅": "Tedarik Merkezi", 
    "需求大厅": "Talep Merkezi",
    "解决方案": "Çözümler",
    "增值服务": "Ek Hizmetler",
    "服务": "Hizmetler",
    
    // 帮助中心
    "帮助中心": "Yardım Merkezi",
    "平台规则": "Platform Kuralları",
    "常见问题": "SSS",
    "安全保障": "Güvenlik",
    "联系我们": "İletişim",
    
    // 产品分类
    "热门产品分类": "Popüler Ürün Kategorileri",
    "智能无人机制造": "Akıllı İHA Üretimi",
    "无人机": "İnsansız Hava Aracı",
    "螺旋桨": "Pervane",
    "RC电子配件": "RC Elektronik Aksesuarlar",
    "起落架和收起": "İniş Takımı ve Toplama",
    "碳纤维材料": "Karbon Fiber Malzeme",
    "无人机遥控器": "İHA Kumandası",
    
    // 公司信息
	"帮助与支持": '‌Yardım ve Destek',
    "关于琴航": "Qinhang Hakkında",
    "了解琴航": "Şirket Profili",
    "加入琴航": "Kariyer",
    "投资者关系": "Yatırımcı İlişkileri",
    "可持续发展": "Sürdürülebilirlik",
    "廉洁举报": "Etik İhlal Bildirimi",
    
    // 新闻动态
    "新闻动态": "Haberler ve Güncellemeler",
    "琴航资讯": "Şirket Haberleri",
    "行业动态": "Sektör Trendleri",
    "最新科技": "Teknoloji Güncellemeleri",
    
    // 版权信息
    "Copyright © 2025 琴航（广东横琴）科技有限公司": "Copyright © 2025 Qinhang (Guangdong Hengqin) Teknoloji Ltd. Şti.",
    "版权所有": "Tüm hakları saklıdır",
    "使用条款": "Kullanım Şartları",
    "网站地图": "Site Haritası",
    
    // 产品分类补充
    "元器件": "Elemanlar",
    "应急装备": "Acil Durum Ekipmanları",
    "光学传感器": "Optik Sensörler",
    "mems": "MEMS",
    "复合材料": "Kompozit Malzemeler",
    "低空飞行器": "Alçak İrtifa Hava Araçları",
    "其他": "Diğer"
},
  'product-list': {
    '条件查询': 'Filtreleme',
    '设备分类': 'Ekipman Kategorisi',
    '运输方式': 'Taşıma Yöntemi',
    '产品标签': 'Ürün Etiketleri',
    '供应商类型': 'Tedarikçi Tipi',
    '商品名称': 'Ürün Adı',
    '全部': 'Tümü',
    '供应商店铺': 'Tedarikçi Mağazası',
    '自营店铺': 'Kendi Mağazamız',
    '请输入商品名称': 'Lütfen ürün adı girin',
    '搜索': 'Ara',
    '重置': 'Sıfırla',
    '共 {count} 个结果': '{count} sonuç bulundu',
    '发布时间': 'Yayın Tarihi',
    '查看次数': 'Görüntüleme Sayısı',
    '取消收藏': 'Favorilerden Çıkar',
    '收藏': 'Favorilere Ekle',
    '询价': 'Fiyat Sorgula',
    '人工询价': 'İnsanlı Fiyat Sorgulama',
    '智能询价': 'Akıllı Fiyat Sorgulama',
    '暂无产品': 'Ürün bulunamadı',
    '解决方案应用': 'Çözüm Uygulamaları',
    '您想要的产品': 'İstediğiniz Ürün'
},
  'product-details': {
    '供应大厅': 'Tedarik Merkezi',
    '产品详情': 'Ürün Detayları',
    '取消收藏': 'Favorilerden Çıkar',
    '收藏': 'Favorilere Ekle',
    '加入收藏': 'Favorilere Ekle',
    '加入询盘': 'Teklif İsteğine Ekle',
    '取消询盘': 'Teklif İsteğini İptal Et',
    '1V1专家咨询': '1V1 Uzman Danışmanlık',
    '商品详情': 'Ürün Detayları',
    '用户案例': 'Kullanıcı Örnekleri',
    '服务支持': 'Servis Desteği',
    '专家咨询': 'Uzman Danışmanlık',
    '请留下您的联系方式，方便我们与您联系': 'Lütfen iletişim bilgilerinizi bırakın',
    '也可直接联系客服邮箱': 'Veya doğrudan müşteri hizmetleri e-postasıyla iletişime geçin',
    '请输入您的联系方式': 'Lütfen iletişim bilgilerinizi girin',
    '取 消': 'İptal',
    '确 定': 'Onayla',
    '提交成功': 'Gönderim Başarılı',
    '联系我们': 'İletişim',
    "规格": "Özellikler",
    "价格": "Fiyat",
    "月供应量": "Aylık Tedarik Miktarı",
    "运输方式": "Taşıma Yöntemi",
	
	"规格详情": "Özellikler Detayları",
	"描述": "Açıklama",
},
  'purchase-list': {
      '条件查询': 'Filtreleme',
      '设备分类': 'Ekipman Kategorisi',
      '共 {count} 个设备': '{count} cihaz',
      '发布时间': 'Yayın Tarihi',
      '查看次数': 'Görüntüleme Sayısı',
      '去咨询': 'Danışma Yap',
      '暂无产品': 'Ürün bulunamadı',
      '截止日期': 'Son Teslim Tarihi',
      '数量': 'Miktar'
  },
  'purchase-details': {
      '采购大厅': 'Satınalma Merkezi',
      '需求详情': 'Talep Detayları',
      '进行中': 'Devam Ediyor',
      '采购数量': 'Satın Alma Miktarı',
      '预算金额': 'Bütçe Tutarı',
      '交货期限': 'Teslim Süresi',
      '距离截止还剩': 'Son Tarihe Kalan Süre',
      '采购需求详情': 'Satın Alma Talep Detayları',
      '采购商详情': 'Satınalmacı Detayları',
      '已认证': 'Doğrulanmış',
      '成立时间': 'Kuruluş Tarihi',
      '员工': 'Çalışan Sayısı',
      '相关推荐': 'Önerilen Ürünler',
      '截止时间': 'Son Teslim Tarihi',
      '采购中': 'Satın Alma Sürecinde',
      '数量': 'Miktar',
      '已截止': 'Süre Doldu',
      '天': 'Gün'
  },
  solution:{
    安防光电类供应链: 'Güvenlik ve Optoelektronik Tedarik Zinciri',
    安防光电类供应链介绍: 'Güvenlik ve Optoelektronik Tedarik Zinciri',
    应急救援解决方案: 'Acil Durum Kurtarma Çözümü',
    应急救援解决方案介绍: 'Bu çözüm, platformun yangın ve acil durum kurtarma için temel ürün teknolojilerini temel alarak, modüler ve akıllı ekipman kombinasyonları ile çok senaryolu acil durum ihtiyaçlarını karşılar.',
    noticeTitle: 'İnsansız Hava Aracı Tedarik Zinciri Çözümü',
    description: 'Tekil bileşen ihtiyaçlarından (gövde, güç sistemi) tam sistem taleplerine kadar tüm müşteri gereksinimlerini karşılıyoruz.',
    返回上页: 'Önceki Sayfa',
    '单项需求策略': 'Tek Bileşen Stratejisi',
    整机需求策略: 'Tam Sistem Stratejisi',
    服务流程: 'Hizmet Süreci',
    质量保障与售后服务: 'Kalite Güvencesi ve Satış Sonrası Hizmet',
    相关产品: 'İlgili Ürünler',
    产品详情: 'Ürün Detayları',
    了解更多产品: 'Daha Fazla Ürün Keşfet',
    更多产品: 'Daha Fazla Ürün',
    规格: 'Özellikler',
    深入了解: 'Detaylı Bilgi',
    相关解决方案: 'İlgili Çözümler',
    查看详情: 'Detayları Görüntüle',
    您当前位置: 'Bulunduğunuz Konum',
    '您当前位置：首页': 'Ana Sayfa > Bulunduğunuz Konum',
    应用场景及解决方案: 'Uygulama Senaryoları ve Çözümler',
    核心优势: 'Temel Avantajlar',
    '核心优势描述': 'Hidrolik kesme sistemleri, su altı kurtarma robotları gibi akıllı ekipmanlarla entegre çözümlerimiz, şehir kurtarma ve endüstriyel kazalarda verimliliği artırır.',
    '基础模块：消防单兵守护系统': 'Temel Modül: Yangın Ekipmanı Koruma Sistemi',
    '消防单兵守护系统定位': 'Sistem Konumlandırması',
    '消防单兵守护系统定位描述': 'Gerçek zamanlı hayati veri izleme sağlayarak kurtarma ekiplerinin güvenliğini maksimum düzeye çıkarır.',
    '功能模块与产品组成': 'Fonksiyonel Modüller ve Ürün Kompozisyonu',
    '功能模块': 'Fonksiyonel Modüller',
    '对应产品/技术': 'İlgili Ürün/Teknoloji',
    '技术参数与用途': 'Teknik Özellikler ve Kullanım Alanları',
    '系统优势': 'Sistem Avantajları',
    '应用场景': 'Uygulama Senaryoları',
    '实时定位与导航': 'Gerçek Zamanlı Konumlandırma ve Navigasyon',
    '北斗三号融合终端': 'Beidou 3 Entegre Terminali',
    '定位误差参数': 'Yatay hata ≤3m, dikey hata <0.5m, sinyal olmayan alanda kısa mesaj iletişimi desteklenir.',
    '生命体征监测': 'Yaşam Belirtileri İzleme',
    '单兵生命体征传感器': 'Tek Kişilik Yaşam Belirtileri Sensörü (Koruma Giysisine Entegre)',
    '生命体征参数': 'Kalp atış hızı, sıcaklık ve kan oksijen doygunluğunun gerçek zamanlı izlenmesi ve anormal değerler için otomatik alarm.',
    '环境风险感知': 'Çevresel Risk Algılama',
    '手持式长波红外成像气体检测仪': 'El Tipi Uzun Dalga Kızılötesi Görüntüleme Gaz Dedektörü',
    '气体检测参数': '16 tür zararlı gazı (CO, H2S vb.) tespit eder, hassasiyet ±1ppm.',
    '氧气余量监控': 'Oksijen Kalan Miktarı İzleme',
    '智能氧气瓶压力传感器': 'Akıllı Oksijen Tüpü Basınç Sensörü',
    '氧气监控参数': 'Kalan oksijen süresini gerçek zamanlı gösterir, düşük basınç uyarısı (eşik ≤5MPa).',
    '通讯与数据回传': 'İletişim ve Veri Geri Dönüşü',
    '卫星电话融合终端': 'Uydu Telefonu Entegre Terminali',
    '通讯参数': 'Komuta merkezine ses aramaları ve termal görüntüleme video iletimini destekler.',
    '多维度安全防护': 'Çok Boyutlu Koruma',
    '多维度安全防护描述': 'Fizyolojik durumdan çevresel risklere, tam kapsamlı izleme uyarısı.',
    '轻量化集成设计': 'Hafif Entegre Tasarım',
    '轻量化集成设计描述': 'Toplam ağırlık <2kg, kurtarma personelinin hareketliliğini etkilemez.',
    '智能决策支持': 'Akıllı Karar Desteği',
    '智能决策支持描述': 'AI algoritması verileri otomatik olarak analiz eder, tahliye yolları ve ilk yardım önerileri sunar.',
    '高层火灾': 'Yüksek Katlı Bina Yangını',
    '高层火灾描述': 'Beidou konumlandırma ile kat konumu, boğulma riskini önlemek için oksijen kalan miktarı uyarısı.',
    '化工爆炸': 'Kimyasal Patlama',
    '化工爆炸描述': 'Gaz dedektörü gerçek zamanlı alarmı, komuta merkezinden uzaktan tahliye rotası yönlendirmesi.',
    '地下隧道': 'Yeraltı Tüneli',
    '地下隧道描述': 'Kısa mesaj fonksiyonu GPS sinyali olmadan iletişim ve konumlandırmayı sağlar.',
    '消防单兵守护系统定位': 'İtfaiyeci Koruma Sistemi Konumlandırması',
    '消防单兵守护系统定位描述': 'İtfaiyeci Koruma Sistemi, acil kurtarmanın temel güvenlik garantisidir. Konumlandırma, izleme ve iletişim işlevlerini entegre ederek, kurtarma personeli için gerçek zamanlı yaşam güvenliği garantisi sağlar ve komuta merkezine hassas veri desteği sunar.',
    '功能模块': 'İşlev Modülleri',
    '对应产品/技术': 'İlgili Ürünler/Teknolojiler',
    '技术参数与用途': 'Teknik Parametreler ve Kullanım',
},
  'solution-details': {
      '解决方案标题': 'Çözüm Başlığı',
      '方案详情': 'Çözüm Detayları',
      '文章标题': 'Makale Başlığı',
      '文章描述': 'Makale Açıklaması',
      '一站式数据资产管理': 'Entegre Veri Varlık Yönetimi',
      '业务挑战': 'İş Zorlukları',
      '解决方案': 'Çözüm',
      '方案价值': 'Çözüm Değeri',
      '1V1专家咨询': '1V1 Uzman Danışmanlık',
      '端到端解决方案，加速释放数据价值': 'Uçtan Uca Çözümlerle Veri Değerinin Açığa Çıkarılması',
      '数据平台': 'Veri Platformu',
      '数据管理平台': 'Veri Yönetim Platformu',
      '数据仓库': 'Veri Ambarı',
      '咨询流程': 'Danışmanlık Süreci',
      '需求咨询': 'Talep Danışmanlığı',
      '初步沟通': 'Ön Görüşme',
      '方案交流': 'Çözüm Paylaşımı',
      '商务流程': 'Ticari Süreç',
      '提交相关需求，描述业务背景': 'İlgili talepleri ve iş bağlamını gönderin',
      '需求确认，对平台心疑惑，解决合作顾虑': 'Talep onayı ve işbirliği endişelerinin giderilmesi',
      '针对相关方案进行详述并就技术问题深讨': 'Teknik detayların derinlemesine tartışılması',
      '方案确定后，开始执行商务流程': 'Ticari süreçlerin başlatılması',
      '已截止': 'Süre Doldu',
      '暂无数据': 'Veri bulunamadı'
  },
'news-list': {
    '新闻中心': 'Haberler ve Güncellemeler',
    '中国智造 走向世界': 'Çin Yapımı Akıllı Üretim, Dünyaya Açılıyor',
    '点击查看更多': 'Daha Fazla Görüntüle'
},

// ... existing code ...
'news-details': {
    '新闻中心': 'Haberler ve Güncellemeler',
    '新闻详情': 'Haber Detayları',
    '发布日期': 'Yayın Tarihi',
    '平台信息': 'Platform Bilgileri'
},

// ... existing code ...
'about': {
  '关于我们': 'Hakkımızda',
  '更新时间': 'Güncelleme Zamanı: ',
  '新闻详情': 'Haber Detayları',
  '了解琴航': 'Qinhang\'ı Tanıyın',
  '琴航文化': 'Şirket Kültürü',
  '核心优势': 'Temel Avantajlar',
  '股东背景': 'Hissedar Profili',
  '政策支持': 'Politika Desteği',
  '展望未来': 'Gelecek Vizyonu',
  '您当前的位置：首页': 'Mevcut Konumunuz: Ana Sayfa',
  
  // 模块1
  '成立背景':'Kuruluş Arka Planı',
  'txt1':'Düşük irtifa ekonomisi stratejik bir yeni endüstri olarak büyük potansiyele sahiptir. Son yıllarda havacılık endüstrisi hızla gelişmiş, birçok teknoloji şirketi ortaya çıkmış ve eksiksiz bir endüstri zinciri oluşmuştur, ancak havacılık endüstri ürünlerinin sınır ötesi satışı hala başlangıç aşamasındadır.',
  
  '公司简介':'Şirket Profili',
  'txt2':'Qinhang Teknoloji, Çin\'in ilk havacılık ve uzay endüstri ürünleri için sınır ötesi tek duraklı hizmet platformudur. Aralık 2024\'te kurulan şirket, "çift döngü" stratejisine yanıt vererek havacılık endüstri zinciri şirketlerinin uluslararası ticaret deneyim eksikliğini gidermeyi amaçlamaktadır.',
  
  '股东结构':'Hissedar Yapısı',
  'txt3':'Zhuhai devlet sermayesi konsorsiyumu tarafından yönetilen hisse yapımız, Dah Hengqin Grubu, Zhuhai Düşük İrtifa Endüstri Yatırım Şirketi ve Zhuhai Fuarcılık Grubu gibi kuruluşları içermektedir.',
  
  '团队力量':'Ekip Gücü',
  'txt4':'Çekirdek ekibimiz Çin Havacılık Bilimi ve Teknolojisi, Poly Savunma, askeri kuruluşlar ve Langhua Grubu gibi kurumlardan gelmekte olup, 10+ yıllık endüstri deneyimine sahiptir.',

  // 模块2
  '战略定位':'Stratejik Konumlandırma',
  'txt5':'"Bir standart, iki ekosistem, üç varlık" gelişim modeliyle Çin havacılık endüstri standartlarının uluslararasılaşmasını teşvik ediyoruz.',
  
  '发展目标':'Gelişim Hedefleri',
  'txt6':'Havacılık endüstri ürünleri ithalat/ihracatında lider olmayı hedefliyoruz. Dijital ve uluslararası ticaret sistemleri kurarak Çin standartlarını küresel ölçekte yaygınlaştırmayı amaçlıyoruz.',

  // 模块3
  'txt7':'Hizmetlerimiz gümrükleme, lojistik ve finansman dahil tüm sınır ötesi ticaret süreçlerini kapsar.',
  
  '技术亮点':'Teknik Özellikler',
  'txt8':'Dijital platformumuz uluslararası standartlarla uyumlu olup Çin havacılık teknolojilerinin sertifikasyonunu kolaylaştırır.',
  
  '差异化优势':'Farklılaştırıcı Avantajlar',
  'txt9':'Devlet sermayesi desteğiyle istikrarlı kaynak sağlıyor ve tüm endüstri zinciri hizmetleri sunuyoruz.',
  
  '海外资源优势':'Uluslararası Kaynak Avantajları',
  'txt10':'Uluslararası tedarik zinciri entegrasyonu ve pazar genişletme konularında uzmanlaşmış global ekibimizle hizmet veriyoruz.',
  
  '股东资源':'Hissedar Kaynakları',
  'txt11':'Çin Uluslararası Havacılık Fuarı kaynaklarını kullanarak marka ve kanavantajlarımızı güçlendiriyoruz.',

  // 模块4
  '横琴战略地位':'Hengqin\'in Stratejik Konumu',
  'txt12':'Hengqin-Guangdong-Makao Derin İşbirliği Bölgesi\'nin merkezinde yer alarak vergi avantajlarından yararlanıyoruz.',
  
  '政策赋能':'Politika Destekleri',
  'txt13':'Hengqin Master Planı kapsamında yüksek teknoloji üretimini ve inovasyonu destekliyoruz.',

  // 模块5
  '短期规划':'Kısa Vadeli Planlar',
  'txt14':'Platform yeteneklerimizi genişleterek İHA endüstrisi gibi yeni alanlara odaklanıyoruz.',
  
  '长期愿景':'Uzun Vadeli Vizyon',
  'txt15':'Küresel havacılık endüstrisi ticaret merkezi olmayı hedefliyor, blok zinciri ve AI teknolojilerini entegre ediyoruz.',
  
  'txt16':'Hengqin Grubu olarak ulusal düşük irtifa ekonomisi politikalarını aktif şekilde destekliyoruz.',

  'hotProducts': 'Popüler Ürün Kategorileri',
  'productCategories': `Akıllı İHA Üretimi<br>
                      İnsansız Hava Aracı<br>
                      Pervane<br>
                      RC Elektronik Aksesuarlar`,

  'helpSupport': 'Yardım ve Destek',
  'platformRules': 'Platform Kuralları',
  'commonQuestions': 'SSS',
  'securityGuarantee': 'Güvenlik Garantisi',
  'contactUs': 'İletişim',

  'aboutQinhang': 'Qinhang Hakkında',
  'aboutUs': 'Hakkımızda',
  'joinUs': 'Bize Katılın',
  'investorRelations': 'Yatırımcı İlişkileri',
  'sustainability': 'Sürdürülebilirlik',
  'reportMisconduct': 'Etik İhlal Bildirimi',

  'newsUpdates': 'Haber Güncellemeleri',
  'companyNews': 'Şirket Haberleri',
  'industryTrends': 'Endüstri Trendleri',
  'latestTech': 'Son Teknolojiler',
  'companyAddress': 'Adres: Zhuhai Uluslararası Teknoloji İnovasyon Merkezi, Bina 7, Oda 708-2, Houpu Yolu No:398, Xiangzhou Bölgesi, Zhuhai',
  'copyright': `Tüm hakları saklıdır&nbsp;©&nbsp;2025&nbsp;Qinhang (Guangdong Hengqin) Teknoloji Ltd. Şti.&nbsp;&nbsp;|&nbsp;&nbsp;Gizlilik Politikası&nbsp;&nbsp;|&nbsp;&nbsp;Kullanım Şartları&nbsp;&nbsp;|&nbsp;&nbsp;粤ICP备2025393208号-1&nbsp;&nbsp;|&nbsp;&nbsp;Site Haritası`
},

// ... existing code ...
'collect-list': {
    "我的收藏": "Favorilerim",
    "返回个人中心": "Profil Sayfasına Dön",
    "取消收藏": "Favorilerden Kaldır",
    "暂无产品": "Ürün bulunamadı"
},
'contact-us': {
'标题': 'İletişim',
'展会介绍': 'KingHang (Guangdong Hengqin) Teknoloji Ltd. Şti., havacılık ve uzay endüstrisi ürünleri için sınır ötesi tek durak hizmet platformunda lider bir şirket olarak, küresel müşterilere her zaman verimli ve profesyonel endüstriyel çözümler sunmaya kendini adamıştır. Derin sektör birikimimiz ve yenilikçi hizmet modelimizle, uluslararası tedarikçiler ve talep sahipleri arasında bir köprü kurmayı başardık ve küresel havacılık endüstrisinin verimli gelişimine katkıda bulunuyoruz. İstanbul, Türkiye gibi uluslararası pazarlarda, KingHang Teknoloji, yerelleştirilmiş hizmet ekipleri ve dijital platformlar aracılığıyla müşterilere tedarik zinciri yönetiminden teknik desteğe kadar tam hizmet sunan geniş bir işbirliği ağı kurmuştur. Hizmetlerimiz havacılık bileşenleri, ekipman ve teknik çözümleri kapsar ve her aşamanın en yüksek uluslararası standartlara uygun olmasını sağlar. Gelecekte, KingHang Teknoloji küresel düzenini derinleştirmeye, gelişmekte olan pazarları genişletmeye ve küresel havacılık endüstrisinin gelişimine yeni ivme kazandırmaya devam edecektir. Daha fazla iş ortağıyla el ele çalışmayı, mükemmelliği yaratmayı ve endüstri ilerlemesini teşvik etmeyi sabırsızlıkla bekliyoruz.',
'电话': 'Telefon',
'邮箱': 'E-posta：Kinghang@e99.cn',
'图片描述': 'İletişim - KingHang Teknoloji IDEF Savunma Sanayi Fuarı\'na Katılıyor'
},

// ... existing code ...
'shop-list': {
    "未提交购物车": "Sepette Bekleyen",
    "返回个人中心": "Profil Sayfasına Dön",
    "取消": "İptal",
    "暂无产品": "Ürün bulunamadı",
    '提交': 'Gönder'
},

// ... existing code ...
'submit-list': {
    "购物车提交记录": "Sepet Gönderim Geçmişi",
    "返回个人中心": "Profil Sayfasına Dön",
    "暂无提交记录": "Gönderim kaydı bulunamadı"
},

// ... existing code ...
'submit-detail': {
    '购物车提交记录详情': 'Sepet Gönderim Detayları',
    "返回购物车提交记录页": "Gönderim Geçmişine Dön"
},

// ... existing code ...
'Card1': {
    '个人中心': 'Kişisel Merkez',
    '供应商': 'Tedarikçi',
    '采购商': 'Satın Almacı',
    '已完成企业认证': 'Şirket Doğrulaması Tamamlandı',
    '未完成企业认证': 'Şirket Doğrulaması Tamamlanmadı',
    '认证审核中': 'Doğrulama İncelemede',
    '审核未通过,请重新认证': 'İnceleme Başarısız, Lütfen Tekrar Deneyin',
    '编辑资料': 'Bilgileri Düzenle',
    '认证信息': 'Doğrulama Bilgileri',
    '退出登录': 'Çıkış Yap',
    '是否确认退出?': 'Çıkış yapmak istediğinizden emin misiniz?',
    '提示': 'Uyarı',
    '确定': 'Onayla',
    '取消': 'İptal',
    '是否翻译': 'Çince ürün bilgilerini çevirmek ister misiniz?',
    '翻译产品': 'Ürünleri Çevir'
},

'Card2': {
    '本月订单总额': 'Bu Ayki Toplam Sipariş Tutarı',
    '较上月增长': 'Geçen Aya Göre Artış',
    '较上月降低': 'Geçen Aya Göre Azalış',
    '较上月无变化': 'Geçen Aya Göre Değişiklik Yok'
},

'Card3': {
    '待处理订单': 'Bekleyen Siparişler',
    '查看详情': 'Detayları Görüntüle'
},

'Card4': {
    '退货订单': 'İade Siparişleri',
    '查看详情': 'Detayları Görüntüle'
},

'Card5': {
    '我的订单': 'Siparişlerim',
    '查看全部': 'Tümünü Görüntüle',
    '待付款': 'Ödeme Bekleyen',
    '待发货': 'Gönderim Bekleyen',
    '待收货': 'Teslim Bekliyor',
    '收货完成': 'Teslim Alındı',
    '退换货': 'İade ve Değişim'
},

'Card6': {
    '采购需求': 'Satın Alma Talepleri',
    '需求管理': 'Talep Yönetimi',
    '有效采购需求': 'Geçerli Satın Alma Talepleri',
    '待审核需求': 'İnceleme Bekleyen Talepler'
},

'Card7': {
    '账户安全': 'Hesap Güvenliği',
    '安全等级': 'Güvenlik Seviyesi',
    '企业认证': 'Şirket Doğrulaması',
    '已认证': 'Doğrulandı',
    '未完成企业认证': 'Şirket Doğrulaması Tamamlanmadı',
    '审核未通过,请重新认证': 'Doğrulama Başarısız, Lütfen Tekrar Deneyin',
    '认证审核中': 'Doğrulama İncelemede',
    '高': 'Yüksek'
},

'Card8': {
    '收藏夹': 'Favoriler',
    '查看全部': 'Tümünü Görüntüle',
    '暂无收藏产品': 'Favori Ürün Bulunmuyor'
},

'Card9': {
    '消息中心': 'Mesaj Merkezi',
    '查看全部': 'Tümünü Görüntüle',
    '订单发货通知': 'Sipariş Gönderim Bildirimi',
    '您的订单 {orderId} 已发货': 'Siparişiniz {orderId} gönderildi',
    '{time} 前': '{time} önce'
},

'Card10': {
    '我的产品': 'Ürünlerim',
    '新增产品': 'Yeni Ürün Ekle',
    '全部': 'Tümü',
    '已上架': 'Yayında',
    '未上架': 'Yayında Değil',
    '审核中': 'İncelemede',
    '审核通过': 'Onaylandı',
    '审核失败': 'Reddedildi',
    '提交审核': 'İncelemeye Gönder',
    '下架': 'Yayından Kaldır',
    '上架': 'Yayına Al',
    '编辑': 'Düzenle',
    '删除': 'Sil',
    '暂无产品': 'Ürün Bulunmuyor',
    '上传图片': 'Resim Yükle',
    '导入产品': 'Ürün İçe Aktar'
},

'Card11': {
    '我的产品': 'Ürünlerim',
    '新增需求': 'Yeni Talep Ekle',
    '返回个人中心': 'Profile Dön',
    '全部': 'Tümü',
    '审核中': 'İncelemede',
    '审核通过': 'Onaylandı',
    '审核失败': 'Reddedildi',
    '提交审核': 'Onayla',
    '编辑': 'Düzenle',
    '删除': 'Sil',
    '暂无需求': 'Talep bulunamadı',
    "已通过": "Onaylı",
    "审核中1": "İncelemede",
    "未通过": "Reddedildi",
    "未审核": "Beklemede"
},

'Card12': {
    '我的订单': 'Siparişlerim',
    '返回个人中心': 'Profile Dön',
    '所有订单': 'Tüm Siparişler',
    '待付款': 'Ödeme Bekliyor',
    '待发货': 'Kargoya Hazır',
    '已发货': 'Kargoda',
    '收货完成': 'Teslim Edildi',
    '退换货': 'İade/Değişim',
    '暂无需求': 'Talep bulunamadı',
    '提交审核': 'Onayla',
    '编辑': 'Düzenle',
    '删除': 'Sil',
    '退款': 'İade Talep Et'
},

// ... existing code ...
'Card13': {
    '未提交购物车': 'Sepette Bekleyen',
    '查看全部': 'Tümünü Görüntüle',
    '暂无产品': 'Ürün bulunamadı'
},

'Card14': {
    '购物车提交记录': 'Sepet Gönderim Geçmişi',
    '查看全部': 'Tümünü Görüntüle',
    '暂无提交记录': 'Gönderim kaydı bulunamadı'
},

// ... existing code ...
'userEdit': {
    '修改个人信息': 'Kişisel Bilgileri Düzenle',
    '头像': 'Profil Fotoğrafı',
    '用户名称': 'Kullanıcı Adı',
    '同步登录账号': 'Giriş Hesabını Senkronize Et',
    '手机号': 'Telefon Numarası',
    '邮箱': 'E-posta',
    '请输入': 'Lütfen Girin',
    '请输入正确的手机号': 'Lütfen Geçerli Bir Telefon Numarası Girin',
    '请输入正确的邮箱': 'Lütfen Geçerli Bir E-posta Adresi Girin',
    '提 交': 'Gönder',
    '修改成功': 'Başarıyla Güncellendi'
},

'login': {
    '用户登录': 'Kullanıcı Girişi',
    '请输入用户名': 'Kullanıcı Adını Girin',
    '密码': 'Şifre',
    '登录': 'Giriş Yap',
    '没有账户?立即注册': 'Hesabınız yok mu? Hemen Kaydolun',
    '未登录或登录过期，请重新登录': 'Oturum açılmadı veya süresi doldu, lütfen tekrar giriş yapın',
    '提示': 'Uyarı',
    '取消': 'İptal'
},

'register': {
  '用户注册': 'Kullanıcı Kaydı',
  '已有账号，去登录': 'Hesabınız var mı? Giriş yapın',
  '用户名': 'Kullanıcı Adı',
  '邮箱': 'E-posta',
  '手机号': 'Telefon Numarası',
  '密码': 'Şifre',
  '再次输入密码': 'Şifreyi Tekrar Girin',
  '用户类型': 'Kullanıcı Tipi',
  '采购商': 'Satın Almacı',
  '供应商': 'Tedarikçi',
  '注册': 'Kaydol',
  '请输入用户名称': 'Lütfen kullanıcı adını girin',
  '请输入邮箱': 'Lütfen e-posta adresini girin',
  '请输入正确的邮箱格式': 'Lütfen geçerli bir e-posta adresi girin',
  '请输入手机号': 'Lütfen telefon numarasını girin',
  '请输入密码': 'Lütfen şifreyi girin',
  '请再次输入密码': 'Lütfen şifreyi tekrar girin',
  '请选择用户类型': 'Lütfen kullanıcı tipini seçin'
},

// ... existing code ...
'personalCenter': {
    '企业认证': 'Kurumsal Doğrulama',
    '基本信息（必填）': 'Temel Bilgiler (Zorunlu)',
    '营业执照': 'İşletme Lisansı',
    '企业名称': 'Şirket Adı',
    '联系人': 'İlgili Kişi',
    '法定代表人身份证': 'Yasal Temsilci Kimlik Belgesi',
    '联系电话': 'İletişim Numarası',
    '组织机构代码': 'Organizasyon Kodu',
    '企业资质信息': 'Şirket Yetkinlik Bilgileri',
    '税务登记证': 'Vergi Kayıt Belgesi',
    '组织机构代码证': 'Organizasyon Kodu Belgesi',
    '开户许可证': 'Banka Hesap Açma İzni',
    '企业资质与能力': 'Şirket Yetkinlikleri ve Kapasitesi',
    '行业经营资质': 'Sektörel İşletme Yetkisi',
    '生产或代理资质': 'Üretim/Temsilcilik Yetkisi',
    '质量管理体系认证': 'Kalite Yönetim Sistemi Sertifikası',
    '环保与安全资质': 'Çevre ve Güvenlik Sertifikaları',
    '供货能力证明': 'Tedarik Kapasite Belgesi',
    '售后服务能力证明': 'Satış Sonrası Hizmet Belgesi',
    '产品资质相关': 'Ürün Sertifikaları',
    '产品质量检测报告': 'Ürün Kalite Test Raporu',
    '产品认证证书': 'Ürün Sertifikası',
    '产品说明书': 'Ürün Kullanım Kılavuzu',
    '其他材料': 'Diğer Belgeler',
    '信用证明': 'Kredi Referansı',
    '无违规声明': 'Kural İhlali Olmadığına Dair Beyan',
    '电商平台运营经验证明': 'E-Ticaret Platformu Deneyim Belgesi',
    '企业荣誉': 'Şirket Başarıları',
    '其他相关资质或证明材料': 'İlgili Diğer Belgeler',
    '提交': 'Gönder',
    '图片或文件': 'Resim veya Dosya',
    '请上传营业执照': 'Lütfen işletme lisansını yükleyin',
    '请输入企业名称': 'Lütfen şirket adını girin',
    '企业名称长度在2到50个字符之间': 'Şirket adı 2-50 karakter arası olmalıdır',
    '请输入联系人姓名': 'Lütfen ilgili kişi adını girin',
    '联系人姓名长度在2到20个字符之间': 'İlgili kişi adı 2-20 karakter arası olmalıdır',
    '邮箱': 'E-posta',
    '请输入邮箱地址': 'Lütfen e-posta adresini girin',
    '请输入联系电话': 'Lütfen iletişim numarasını girin'
},

// ... existing code ...
'personalCenter2': {
    '企业认证': 'Kurumsal Doğrulama',
    '基本信息（必填）': 'Temel Bilgiler (Zorunlu)',
    '业务信息（必填）': 'İş Bilgileri (Zorunlu)',
    '联系方式（必填）': 'İletişim Bilgileri (Zorunlu)',
    '资质相关（必填）': 'Sertifikalar (Zorunlu)',
    '企业名称': 'Şirket Adı',
    '公司注册地址': 'Şirket Kayıt Adresi',
    '公司注册编号': 'Şirket Kayıt Numarası',
    '成立时间': 'Kuruluş Tarihi',
    '公司规模': 'Şirket Ölçeği',
    '采购品类': 'Satın Alma Kategorileri',
    '年采购额范围': 'Yıllık Satın Alma Tutarı Aralığı',
    '主要采购市场': 'Ana Satın Alma Pazarı',
    '预计月采购量': 'Tahmini Aylık Satın Alma Miktarı',
    '公司邮箱': 'Şirket E-postası',
    '公司电话': 'Şirket Telefonu',
    '公司网站': 'Şirket Websitesi',
    '办公地址': 'Ofis Adresi',
    '公司营业执照': 'Şirket İşletme Lisansı',
    '进出口贸易许可证': 'İthalat/İhracat Lisansı',
    '银行账户证明': 'Banka Hesap Belgesi',
    '提交': 'Gönder',
    '图片或文件': 'Resim veya Dosya',
    '提交成功，请耐心等待客服审核通过': 'Başarıyla gönderildi, lütfen onay için bekleyin',
    '提示': 'Uyarı',
    '确定': 'Onayla',
    '取消': 'İptal',
    '提交失败，请稍后重试': 'Gönderim başarısız, lütfen tekrar deneyin',
    '请完善必填信息': 'Lütfen zorunlu alanları doldurun',
    '请输入企业名称': 'Lütfen şirket adını girin',
    '请输入公司注册地址': 'Lütfen şirket kayıt adresini girin',
    '请输入公司注册编号': 'Lütfen şirket kayıt numarasını girin',
    '请选择成立时间': 'Lütfen kuruluş tarihini seçin',
    '请选择公司规模': 'Lütfen şirket ölçeğini seçin',
    '请选择采购品类': 'Lütfen satın alma kategorisini seçin',
    '请选择年采购额范围': 'Lütfen yıllık satın alma tutarı aralığını seçin',
    '请选择主要采购市场': 'Lütfen ana satın alma pazarını seçin',
    '请输入预计月采购量': 'Lütfen tahmini aylık satın alma miktarını girin',
    '请输入公司邮箱': 'Lütfen şirket e-postasını girin',
    '请输入公司电话': 'Lütfen şirket telefonunu girin',
    '请输入公司网站': 'Lütfen şirket websitesini girin',
    '请输入办公地址': 'Lütfen ofis adresini girin',
    '请上传公司营业执照': 'Lütfen şirket işletme lisansını yükleyin',
    '请上传进出口贸易许可证': 'Lütfen ithalat/ihracat lisansını yükleyin',
    '请上传银行账户证明': 'Lütfen banka hesap belgesini yükleyin'
},
'solution4':{
    'txt1':'Hassas Sensörlerle Küresel Akıllı Üretimin Geleceğine Öncülük Edin',
    'txt2':'Endüstriyel otomasyon, İHA navigasyonu, robot kontrolü ve otomotiv elektroniği gibi yüksek hassasiyet gerektiren alanlarda jiroskop seçimi ekipman performansını ve güvenirliğini doğrudan etkiler. Profesyonel endüstriyel ürünler sınır ötesi ticaret platformu olarak müşterilerin karşılaştığı zorlukları iyi anlıyoruz:',
    'txt3':'Karmaşık parametreler: Ölçek aralığı, sıfır sapma stabilitesi, gürültü gibi özelliklerin uygulama senaryolarıyla nasıl eşleştirileceği',
    'txt4':'Zorlu çevre koşulları: Yüksek sıcaklık, darbe ve titreşim altında stabilite sağlama',
    'txt5':'Entegrasyon zorlukları: Arayüz uyumluluğu ve devre tasarımının optimize edilmesi',
    'txt6':'Çözümümüz: ASG1000 serisi MEMS jiroskopların teknik avantajlarıyla "hassas seçim desteği + tam süreç teknik hizmetler" sunarak ürün entegrasyonu ve seri üretimi hızlandırıyoruz',
    'txt7':'ASG1000 Serisi Temel Avantajlar',
    'txt8':'Askeri sınıf performansla zorlu koşullara dayanıklılık',
    'txt9':'Yüksek hassasiyet: 0.5 dph\'ye kadar düşük sıfır sapma stabilitesi (ASG1100-P5), 0.06°/√h açısal rastgele hata ile hassas navigasyon ve pozisyon kontrolü için ideal',
    'txt10':'Geniş sıcaklık aralığı: -55℃ ile +125℃ arası çalışma, GJB 150.3A/4A testlerini geçmiş',
    'txt11':'Darbe ve titreşim direnci: 4000g darbe dayanımı, 6.06grms titreşim güvenilirliği ile GJB 150.18A standartlarına uyum',
    'txt12':'Esnek uyum ve çoklu senaryo desteği',
    'txt13':'Tak-çalıştır tasarımıyla hızlı entegrasyon',
    'txt14':'Standart SPI arayüzü: ≥2kHz veri hızıyla ana kontrolcülerle uyumlu',
    'txt15':'Kompakt boyut: 11mm×11mm ölçüleriyle sınırlı alanlara uygun',
    'txt16':'Devre optimizasyon rehberi: Pin tanımları ve kapasitor eşleme önerileri (örn. V4P5 için 1μF kapasitor) ile geliştirme sürecini kısaltma',
    'txt17':'Hizmetlerimiz: Seçimden seri üretime tam destek',
    'txt18':'Hassas ürün seçim desteği',
    'txt19':'Senaryo bazlı eşleme: Uygulama gereksinimlerinize (menzil, çevre, güç tüketimi) göre optimize modeller öneriyoruz',
    'txt20':'Örnek: İHA uçuş kontrolü için yüksek dinamik tepki - 100Hz bant genişlikli ASG1500 serisi gerçek zamanlı pozisyon ayarı sağlar',
    'txt21':'Parametre karşılaştırma analizi: Sapma tekrarlanabilirliği ve doğrusal olmama gibi kritik ölçütleri yorumlayarak tasarım risklerini azaltma',
    'txt22':'Teknoloji desteği',
    'txt23':'Referans tasarım paketi: Şematik diyagramlar, PCB yerleşim önerileri ve sürücü kodları içerir',
    'txt24':'Özelleştirme hizmetleri: Özel paketleme veya çıkış protokolleri için OEM/ODM desteği',
    'txt25':'Kalite ve tedarik zinciri güvencesi',
    'txt26':'Tam süreç kalite kontrol: GJB 548B ve GJB 7952 gibi askeri standartlara uygunluk',
    'txt27':'Sınırsız lojistik: DDP/DAP hizmetleriyle küresel dağıtım ağı',
    'txt28':'Diğer avantajlar',
    'txt29':'Teknik referanslar',
    'txt30':'Askeri teknoloji ekibinden 10+ yıllık MEMS sensör deneyimi',
    'txt31':'Tek duraklı hizmet',
    'txt32':'Seçim danışmanlığından toplu satın almaya kadar tüm süreçler',
    'txt33':'Şeffaf veri',
    'txt34':'Üçüncü parti test raporları (titreşim düzeltme katsayısı, sıcaklık kayma eğrileri) ile güvenli tedarik',

    'tab1': 'Model',
    'tab2': 'Ölçek Aralığı',
    'tab3': 'Temel Özellikler',
    'tab4': 'Tipik Uygulama Senaryoları',
    'tab5': 'Ultra Düşük Gürültü & Yüksek Stabilite',
    'tab6': 'İHA Yükseklik Kontrolü | Hassas Cihazlar',
    'tab7': 'Yüksek Bant Genişliği (≥100Hz) | Titreşim Direnci',
    'tab8': 'Endüstriyel Robotlar | Otonom Sürüş'
},
AddDemand: {
    'xzcgxq': 'Yeni Satın Alma Talebi Ekle',
    'bjcgxq': 'Satın Alma Talebini Düzenle',
    'cpmc': 'Ürün Adı',
    'cplb': 'Ürün Kategorisi',
    'cgsl': 'Satın Alma Miktarı',
    'dw': 'Birim',
    'ysje': 'Bütçe Tutarı',
    'jhqx': 'Teslimat Tarihi',
    'bmjzsj': 'Başvuru Son Tarihi',
    'cpzt': 'Ürün Ana Resmi',
    'cpxjt': 'Ürün Detay Resimleri',
    'cpfj': 'Ürün Ekleri',
    'cpyqxq': 'Ürün Gereksinim Detayları',
    'qsr': 'Lütfen girin',
    'qxz': 'Lütfen seçin',
    'tbdxjt': 'Detay Resimlerine Senkronize Et',
    'tj': 'Gönder',
    'qsrcpmc': 'Lütfen ürün adını girin',
    'qsrcgsl': 'Lütfen satın alma miktarını girin',
    'qsrdw': 'Lütfen birimi girin',
    'qxzcplb': 'Lütfen ürün kategorisini seçin',
    'qsrysje': 'Lütfen bütçe tutarını girin',
    'qsrjhqx': 'Lütfen teslimat tarihini girin',
    'qxzbmjzsj': 'Lütfen başvuru son tarihini seçin',
    'qsrcpgxq': 'Lütfen ürün özellik gereksinimlerini girin',
    'qsccpzt': 'Lütfen ürün ana resmini yükleyin',
    'qsccpxjt': 'Lütfen ürün detay resimlerini yükleyin',
    'xgcg': 'Başarıyla düzenlendi',
    'xzcg': 'Başarıyla eklendi',
    'hqcgxqxqsb': 'Satın alma talep detayları alınamadı'
},
product: {
    '请先登录后查看产品详情': 'Ürün detaylarını görüntülemek için lütfen önce giriş yapın',
    '请先登录后继续操作': 'Devam etmek için lütfen önce giriş yapın',
    '提示': 'Uyarı',
    '去登录': 'Giriş Yap',
    '取消': 'İptal'
}
};
export default tr_TR;
